import { ReactNode } from 'react';
import { AnchorPropsInternal } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

export type ProfilePostsTabType = {
  label: (props: AnchorPropsInternal) => ReactNode;
};

export interface ProfilePostsTabsProps {
  options: ProfilePostsTabType[];
  className?: string;
}

export const ProfilePostsTabs = ({ options, className }: ProfilePostsTabsProps) => (
  <div className={cn(styles.wrapper, className)}>
    {options.map((option) => option.label({ className: styles.item }))}
  </div>
);

const styles = {
  wrapper: cn('relative z-10 flex'),
  item: cn(
    'relative box-border flex h-14 max-w-40 flex-1 cursor-pointer items-center border-b-border border-t-[transparent] bg-white px-3 py-0 text-base leading-normal text-primary',
    'not-first-of-type:border-l-border',
    'active:border-2 active:border-t-blue-20 active:border-b-transparent active:text-active',
    'hover:font-semibold'
  )
};
